import { baseApi } from "./baseApi";

const CONTRACTOR_BASE_URL = "/contractors";

export const contractorApi = baseApi.injectEndpoints({
  tagTypes: ["Contractor"],

  endpoints: (build) => ({
    addContractor: build.mutation({
      query: (body) => ({
        url: CONTRACTOR_BASE_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "Contractor", id: _id },
        { type: "Contractor", id: "LIST" },
      ],
    }),

    listContractor: build.query({
      query: (params) => ({
        url: CONTRACTOR_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({ type: "Contractor", _id })),
              { type: "Contractor", id: "LIST" },
            ]
          : [{ type: "Contractor", id: "LIST" }],
    }),

    getDDLContractorList: build.query({
      query: (params) => ({ url: `${CONTRACTOR_BASE_URL}/ddl`, params }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({ type: "Contractor", _id })),
              { type: "Contractor", id: "DDL" },
            ]
          : [{ type: "Contractor", id: "DDL" }],
    }),

    getDDLContractorListByShipmentStatus: build.query({
      query: (params) => ({
        url: `${CONTRACTOR_BASE_URL}/ddl-by-shipment-status`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ value }) => ({ type: "Contractor", id: value })),
              { type: "Contractor", id: "DDL_BY_SHIPMENT_STATUS" },
            ]
          : [{ type: "Contractor", id: "DDL_BY_SHIPMENT_STATUS" }],
      // Description: Returns contractors (value: _id, label: name + contractorId, phone, shipments)
      // for shipments with status="Delivered" and paymentCollectionStatus="Uncollected"
    }),

    getContractorDetail: build.query({
      query: (contractId) => `${CONTRACTOR_BASE_URL}/${contractId}`,
      providesTags: (result, error, { _id }) => [
        { type: "Contractor", _id },
        { type: "Contractor", id: "LIST" },
      ],
    }),

    updateContractor: build.mutation({
      query: ({ _id, ...body }) => ({
        url: `${CONTRACTOR_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id: id }) => [
        { type: "Contractor", id },
        { type: "Contractor", id: "LIST" },
      ],
    }),

    listContractorShipments: build.query({
      query: (params) => ({
        url: `${CONTRACTOR_BASE_URL}/${params.contractorId}/shipments`,
        params,
      }),
      providesTags: (_result, _error, { _id: id }) => [
        { type: "Contractor", id },
        { type: "Contractor", id: "LIST" },
      ],
    }),

    listContractorPrices: build.query({
      query: (params) => ({
        url: `${CONTRACTOR_BASE_URL}/${params.contractorId}/pricings`,
        params,
      }),
      providesTags: (_result, _error, { _id: id }) => [
        { type: "Contractor", id },
        { type: "Contractor", id: "LIST" },
      ],
    }),

    searchContractorsForDeliveryCollection: build.query({
      query: ({ account, entity, query, status }) => ({
        url: `${CONTRACTOR_BASE_URL}/search`,
        params: { account, entity, query, status },
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "Consolidation",
                _id,
              })),
              { type: "Consolidation", id: "SEARCH" },
            ]
          : [{ type: "Consolidation", id: "SEARCH" }],
    }),

    searchContractorWithVehicle: build.query({
      query: ({ account, entity, query }) => ({
        url: `${CONTRACTOR_BASE_URL}/search-with-vehicle`,
        params: { account, entity, query },
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "Contractor",
                id: _id,
              })),
              { type: "Contractor", id: "SEARCH_WITH_VEHICLE" },
            ]
          : [{ type: "Contractor", id: "SEARCH_WITH_VEHICLE" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListContractorQuery,
  useLazyListContractorQuery,
  useGetDDLContractorListQuery,
  useLazyGetDDLContractorListQuery,
  useAddContractorMutation,
  useGetContractorDetailQuery,
  useUpdateContractorMutation,
  useGetDDLContractorListByShipmentStatusQuery,
  useLazyGetDDLContractorListByShipmentStatusQuery,

  useLazyListContractorShipmentsQuery,
  useLazyListContractorPricesQuery,
  useSearchContractorWithVehicleQuery,
  useLazySearchContractorWithVehicleQuery,

  useLazySearchContractorsForDeliveryCollectionQuery,
} = contractorApi;
